import React, { Component } from 'react';
import InverterEnergyGeneration from './InverterEnergyGeneration';
import InverterPowerChart from './InverterPowerChart';

class InverterEnergyDetails extends Component {

    constructor(props) {
        super(props);

        this.state = {
            renderState: 'energy'
        }
    }

    getMainContent() {
        return (<InverterEnergyGeneration history={this.props.history} user={this.props.user} inverter={this.props.inverter} />);
    }

    changeRenderState(renderState) {
        this.setState({
            renderState: renderState
        });
    }

    render() {
        return (
            <section className="">
                <div className="col-12">
                    {this.getMainContent()}
                </div>
            </section>
        )
    }
}

export default InverterEnergyDetails;